import { ReactNode } from "react";

interface HeroSectionProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
}

const HeroSection = ({
  eyebrow,
  title,
  description,
  action,
  children,
}: HeroSectionProps) => {
  return (
    <section className="relative overflow-hidden rounded-3xl border border-ink-200/60 bg-white shadow-card">
      {/* gradient mesh background */}
      <div className="absolute inset-0 bg-mesh-1 opacity-100" />
      <div className="absolute inset-0 bg-dotted bg-dot-md opacity-[0.3]" />
      <div className="absolute -top-32 -right-24 w-96 h-96 bg-brand-gradient opacity-[0.08] rounded-full blur-3xl" />

      <div className="relative px-7 py-9 sm:px-10 sm:py-11 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div className="max-w-xl">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 px-2.5 h-6 mb-3 rounded-full bg-white/70 backdrop-blur border border-ink-200/70 text-[11px] font-medium text-ink-600">
              {eyebrow}
            </div>
          )}
          <h1 className="font-display text-hero text-ink-900">{title}</h1>
          {description && (
            <p className="text-[15px] text-ink-600 mt-3 leading-relaxed">
              {description}
            </p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>

      {children && <div className="relative px-7 sm:px-10 pb-9">{children}</div>}
    </section>
  );
};

export default HeroSection;
